<template>
  <v-content>
    <v-container>
      <v-layout justify-center class="mt-5">
        <v-flex xs12 sm8 md5>
          <v-form ref="form" @submit.prevent="login" lazy-validation>
            <h2 class="headline pb-2">Provider Login</h2>
            <p class="body-1 pb-2">
              Log in to manage your submitted listings.
            </p>

            <v-text-field
              v-model="credentials.email"
              label="Email Address"
              solo
              flat
              type="email"
              :rules="[required]"
              :disabled="loading"
            />
            <v-text-field
              v-model="credentials.password"
              label="Password"
              solo
              flat
              type="password"
              :rules="[required]"
              :disabled="loading"
            />

            <div class="mb-3">
              <div class="caption grey--text mb-1">
                Type the characters shown below
              </div>
              <v-layout align-center>
                <div class="captcha-image mr-2" v-html="captchaSvg" />
                <v-btn
                  icon
                  small
                  type="button"
                  :loading="captchaLoading"
                  @click="loadCaptcha"
                  title="Refresh captcha"
                >
                  <v-icon>refresh</v-icon>
                </v-btn>
              </v-layout>
              <v-text-field
                v-model="captchaAnswer"
                label="Enter characters above"
                solo
                flat
                :rules="[required]"
                :disabled="loading"
                class="mt-2"
              />
            </div>

            <v-alert v-if="errorMessage" type="error" class="mb-3">
              {{ errorMessage }}
            </v-alert>

            <v-btn
              depressed
              color="secondary"
              class="white--text ma-0"
              type="submit"
              :loading="loading"
            >
              Log in
            </v-btn>

            <v-layout column class="mt-3">
              <span class="body-2 mb-1">
                <router-link :to="{ name: 'Provider-Forgot-Password' }">
                  Forgot password?
                </router-link>
              </span>
              <span class="body-2">
                Don't have an account?
                <router-link :to="{ name: 'Provider-Register' }">
                  Request one here.
                </router-link>
              </span>
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from "axios";

const baseUrl =
  (window.location.hostname === "localhost"
    ? "http://" + window.location.hostname + ":3000"
    : window.location.origin) + "/api";

export default {
  name: "ProviderLogin",
  data() {
    return {
      credentials: { email: "", password: "" },
      captchaSvg: "",
      captchaToken: "",
      captchaAnswer: "",
      captchaLoading: false,
      loading: false,
      errorMessage: ""
    };
  },
  mounted() {
    this.loadCaptcha();
    if (this.$route.query.expired) {
      this.errorMessage = "Your session expired. Please log in again.";
    }
  },
  methods: {
    required: v => !!v || "This field is required.",

    async loadCaptcha() {
      this.captchaLoading = true;
      this.captchaAnswer = "";
      try {
        const res = await axios.get(`${baseUrl}/providers/captcha`);
        this.captchaSvg = res.data.svg;
        this.captchaToken = res.data.token;
      } catch {
        this.errorMessage = "Could not load CAPTCHA. Please refresh the page.";
      } finally {
        this.captchaLoading = false;
      }
    },

    async login() {
      if (!this.$refs.form.validate()) return;
      this.errorMessage = "";
      this.loading = true;
      try {
        await this.$store.dispatch("loginProvider", {
          ...this.credentials,
          captchaToken: this.captchaToken,
          captchaAnswer: this.captchaAnswer
        });
        if (this.$store.state.providerToken) {
          const redirect = this.$route.query.redirect;
          // Only follow the redirect if it's an internal path (starts with a
          // single "/", not "//" which browsers treat as protocol-relative).
          const isSafeRedirect =
            typeof redirect === "string" &&
            redirect.startsWith("/") &&
            !redirect.startsWith("//");
          this.$router.push(
            isSafeRedirect ? redirect : { name: "Provider-Dashboard" }
          );
        }
      } catch (err) {
        this.errorMessage = err.message || "Login failed. Please try again.";
        await this.loadCaptcha();
        this.$refs.form.resetValidation();
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="less">
form {
  padding: 2em;
  border: 1px solid #ccc;
  border-radius: 0.5em;
}

.captcha-image {
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  display: inline-block;
  line-height: 0;
}
</style>
